<!-- 打印调拨单-海口 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printTransContent" class="print-zone">
            <div style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <div class="order-code">
                            <!-- <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                            <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" /> -->
                        </div>
                        <div class="barfa">
                            <div class="grid-content"><svg id="barcode" /></div>
                        </div>                        
                        <div class="print-title">调拨单</div>
                        <div class="order-detail">
                            <div class="right">单号：{{ orderData.TOCode }}</div>
                            <div class="right">
                                日期：
                                <span>{{ orderData.CreateTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="table_b">
                    <table
                        border="1"
                        cellspacing="0"
                        cellpadding="1"
                        width="100%"
                        style="border-collapse: collapse;table-layout:fixed;border-bottom: none;"
                        bordercolor="#333333"
                    >
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="20%" style="border-bottom: none;">调出仓库</td>
                                <td width="30%" style="border-bottom: none;">{{ orderData.OutWarehouseName }}</td>
                                <td width="20%" style="border-bottom: none;">调入仓库</td>
                                <td width="30%" style="border-bottom: none;">{{ orderData.InWarehouseName }}</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="4%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="16%">
                                    <div><b>汽配编码</b></div>
                                </td>
                                <td width="16%">
                                    <div><b>配件名称</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>车型</b></div>
                                </td>
                                 <td width="9%">
                                    <div><b>产地</b></div>
                                </td>
                                 <td width="8%">
                                    <div><b>规格</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>出库数</b></div>
                                </td>
                                <td width="7%">
                                    <div><b>单价</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>金额</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>调出仓位</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td style="white-space: nowrap; text-overflow: clip; overflow: hidden">{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Origin }}</td>
                                <td>{{ AP.Size }}</td>
                                <td>{{ AP.Count + ' ' + AP.Unit }}</td>
                                <td>{{ AP.CostPrice }}</td>
                                <td>{{ (AP.Count * AP.CostPrice).toFixed(2) }}</td>
                                <td>{{ AP.GoodsLocation }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:right;">合计：</td>
                                <td>{{ allNum }}</td>
                                <td></td>
                                <td>{{ allPrice }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                        <!-- <tfoot>
                            <tr>
                                <td colspan="11">
                                    <div style="display: inline-block; text-indent: 35px; width: 40%">
                                        <span tdata="pageNO" format="#">第#页</span> / <span tdata="pageCount" format="#">共#页</span>
                                    </div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="8" tdata="SubSum" format="#">小计数量：#</div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="10" tdata="SubSum" format="#,##0.00">小计金额：###</div>
                                </td>
                            </tr>
                        </tfoot> -->
                    </table>
                </div>
                <div id="foot">
                    <div class="order-remark">
                        <div style="width: 99%">备注：{{ orderData.Remark }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="sort-set">
                    <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printTransContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            imgUrl: '',
            isPreview: false,
            isDefaultSet: false,
            sortField: '',
            orderData: {},
            loading: false,
            TOCode: ''
        };
    },
    watch: {
        TOCode: {
            handler(newVal, oldVal) {
                if (newVal == oldVal || !this.isInit) return;

                this.$nextTick(function() {
                    // let canvas = this.$refs.canva;
                    // QRCode.toCanvas(
                    //     canvas,
                    //     newVal,
                    //     {
                    //         width: 80,
                    //         height: 80,
                    //         margin: 0,
                    //         scrollX: 0,
                    //         scrollY: 0
                    //     },
                    //     function(error) {}
                    // );
                    // setTimeout(() => {
                    //     html2canvas(canvas, {
                    //         width: 80,
                    //         height: 80,
                    //         scrollX: 0,
                    //         scrollY: 0
                    //     })
                    //         .then(canvasRes => {
                    //             var imgData = canvasRes.toDataURL('image/png');
                    //             this.imgUrl = imgData;
                    //             canvas.style.display = 'none';
                    //         })
                    //         .catch(error => {
                    //         });
                    // }, 1000);
                JsBarcode('#barcode', newVal, {
                    width: 1.1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });                    
                });
            },
            immediate: true
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            let sortField = this.$util.getLocalStorage('trans_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getTransOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 12px 0;
                    }
                    .barfa{display:none;}
                    .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                    
                    .order-detail {
                         color: #000;
                        position: relative;
                        top: -30px;
                        right: 0px;
                    }
                    .order-code {
                        width: 80px;
                        height: 80px;
                        display: inline-block;
                        vertical-align: top;
                    }
                    .qrcode-canvas,.qrcode-image{
                        display:none;
                    }                   
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break : break-all;word-wrap: break-word;
                    }                    
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }                
                `;

                let footStyle = `
                    .order-remark {
                        width: 742px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding-top: 5px;
                        color: #000;
                    }                     
                    .fwb {
                        font-weight: bold;
                        font-size:16px;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;

                let contentHeight = document.getElementById('printTransContent').clientHeight;
                let topHeight = document.querySelector('#printTransContent #top').clientHeight;
                let table_b_Height = document.querySelector('#printTransContent #table_b').clientHeight;
                let tableHeight = document.querySelector('#printTransContent #table').clientHeight;
                let footHeight = document.querySelector('#printTransContent #foot').clientHeight;

                // LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.orderData.TOCode);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_BARCODE(10, 5,  187, 40, '128Auto', this.orderData.TOCode);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    // //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printTransContent #top').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_TABLE(
                    topHeight + 3,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printTransContent #table_b').innerHTML
                );
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_TABLE(
                    topHeight + table_b_Height,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printTransContent #table').innerHTML
                );

                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${footStyle}</style>` + document.querySelector('#printTransContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.$util
                .printedRecord({
                        OrderId: this.printIds[0],
                        Type: 6
                    },true
                );
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getTransOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetPrintTransferOrderData',
                    data: {
                        TOId: this.printIds[0],
                        SortField: this.sortField
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += Number(DetailList[i].Count) * DetailList[i].CostPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    this.orderData = {
                        CreateTime: data.CreateTime,
                        InWarehouseName: data.InWarehouseName,
                        OutWarehouseName: data.OutWarehouseName,
                        Remark: data.Remark,
                        TOCode: data.TOCode,
                        TOId: data.TOId,
                        DetailList: data.DetailList
                    };
                    this.TOCode = data.TOCode;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setSortField(field) {
            this.$util.setLocalStorage('trans_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getTransOrder();
        }
    }
};
</script>
<style lang="less">
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
    .barfa {
        height: auto;
        position: absolute;
        top: 0;
        // right: -10px;
    }    
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
    }
    .row {
        border-top: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
